export const BRAND_MANAGE_SCOPES = ['redirections:manage:brand']
